/* istanbul ignore file */
import { apicall } from 'utils/api';

export function productSearch (query) {
  return apicall(`products/${query}`);
}
